import axios from 'axios'
import { APP_API_BASE } from '@/utils/api-base'

const publicRequest = axios.create({
  baseURL: APP_API_BASE,
  timeout: 15000
})

function unwrap(res) {
  const body = res && res.data
  if (!body) {
    return Promise.reject(new Error('网络异常'))
  }
  if (body.status != null && Number(body.status) !== 200) {
    return Promise.reject(new Error(body.msg || body.message || '请求失败'))
  }
  return body.data
}

/** 供应商公开：生产需求列表 */
export function fetchPublicSealProduceList(token) {
  return publicRequest
    .get('/signstore/public/sealProduce/list', { params: { token } })
    .then(unwrap)
}

/** 供应商公开：标记已发货 */
export function shipPublicSealProduce(id, token) {
  return publicRequest
    .post('/signstore/public/sealProduce/' + id + '/ship', null, { params: { token } })
    .then(unwrap)
}
